<template>
  <div class="wrapper">
    <div ref="autoShiftLoading" class="auto-shift-loading-icon" />
    <div class="auto-shift-loading-title">
      自動入力中です。
    </div>
    <div class="auto-shift-loading-explanation">
      自動入力中は操作できません。このままお待ち下さい。
      <br>
      自動入力されたシフトは水色で表示されます。
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import lottie, { AnimationItem } from 'lottie-web'
import animationData from './AutoShiftLoadingAnimationData.json'

const autoShiftLoading = ref<Element | null>(null)
let anim: AnimationItem | null = null

onMounted(() => {
  if (autoShiftLoading.value) {
    anim = lottie.loadAnimation({
      container: autoShiftLoading.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    })
  }
})
</script>

<style lang="sass" scoped>
.wrapper
  z-index: 100
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100%
  background: rgba(255, 255, 255, 0.8)
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  color: #956134
  .auto-shift-loading-icon
    width: 240px
    height: 240px
  .auto-shift-loading-title
    font-size: 22px
    font-weight: bold
  .auto-shift-loading-explanation
    margin-top: 10px
    font-size: 18px
    text-align: center
</style>
